/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-minhas-listas-share[_ngcontent-%COMP%]{padding:16px}.modal-minhas-listas-share__close[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:8px;cursor:pointer}.modal-minhas-listas-share__section[_ngcontent-%COMP%]{margin-bottom:10px}.modal-minhas-listas-share__footer[_ngcontent-%COMP%]{display:flex;justify-content:flex-end}.modal-minhas-listas-share__footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-left:10px}"];
export { styles as styles };
